import { createContext, useContext } from 'react';
import type { CoinbaseEngUsersAccountManagementApiApiProductRoleDefinition } from '@cbhq/identity-api-hooks/account-management/types';

export type LegalEntity = {
  legalEntityId: string;
  legalEntityName: string;
  roles: string[];
  filteredRoles?: CoinbaseEngUsersAccountManagementApiApiProductRoleDefinition[];
};

export type Organization = {
  organizationId: string;
  organizationName: string;
  legalEntities: LegalEntity[];
  roles: string[];
};

export type OrganizationContextType = {
  selectedOrganization: Organization | undefined;
  selectOrganization: (organizationId: string) => void;
  organizations: Organization[] | undefined;
  error: Error | null;
  retry: () => void;
  hasRequestedOrganizationAccessDenied: boolean;
};

export const OrganizationContext = createContext<OrganizationContextType | null>(null);

export function useOrganization() {
  const context = useContext(OrganizationContext);
  if (context === null) {
    throw new Error('useOrganization must be used within an OrganizationProvider');
  }
  return context;
}
